import { grey } from "@mui/material/colors";
import { LIGHT_GREY } from "styles/oneOffColor";

const styles = {
  leftContainer: (inDialogFlow: boolean) => ({
    p: { xs: 2, md: 4 },
    backgroundColor: LIGHT_GREY,
    marginTop: { xs: 0, md: inDialogFlow ? 0 : 2 },
    marginLeft: { xs: 0, md: inDialogFlow ? 0 : 4 },
    borderRadius: { xs: 0, md: inDialogFlow ? 0 : 4 },
    justifyContent: "flex-end",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }),
  rightContainer: {
    backgroundColor: { xs: LIGHT_GREY, md: "white" },
    p: { xs: 2, md: 4, lg: 6 },
    alignItems: { xs: "flex-start", md: "center" },
  },
  tab: {
    color: grey[700],
    textTransform: "none",
    fontSize: 11,
    borderRadius: 4,
  },
  active: {
    px: 2,
    color: "black",
    backgroundColor: "white",
  },
  annotation: {
    position: "relative",
    verticalAlign: "middle",
    fontSize: 10,
    ml: 0.5,
    color: "purple.main",
  },
  coupon: {
    fontSize: 10,
    backgroundColor: "white",
    color: "green.main",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "yellow.main",
    },
  },
};

export default styles;
